import { ButtonColor } from "sb-resp-ui";
export const getSetButtonProps = (title, onClick, disabled) => {
    return {
        title,
        color: ButtonColor.Primary,
        onClick,
        dataUat: "button-reality-check-set",
        disabled
    };
};
//# sourceMappingURL=getSetButtonProps.js.map